module.exports = __webpack_public_path__ + "static/img/maisui-r.00f1b6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maisui-r.png
// module id = KUA6
// module chunks = 0